import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-771f7793"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "calendar-title"
}, "预约时间", -1));
const _hoisted_2 = {
  class: "calendar-bottom-info"
};
const _hoisted_3 = {
  key: 0,
  class: "day-selected-info"
};
import { computed, ref, watch } from 'vue';
import { reactive } from 'vue';
import { mdToast } from '../../utils/tools';

// 定义父组件传递的属性

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true
    },
    duration: {
      type: Number,
      default: 1
    },
    end_date: {
      type: String,
      default: ''
    },
    disable_date_array: {
      type: Array,
      // ex:2024-08-12
      // eslint-disable-next-line vue/require-valid-default-prop  
      default: []
    },
    enabled_data_array: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop  
      default: []
    }
  },
  emits: ['update:show'],
  setup(__props, {
    emit
  }) {
    const props = __props;

    // 定义emits

    const calendarRef = ref(null);

    // picker依赖show状态
    const showCalendar = computed({
      get() {
        return props.show;
      },
      set(value) {
        emit('update:show', value);
      }
    });
    const currentDate = new Date();

    //最小日期是明天
    const minDate = new Date(currentDate);
    minDate.setDate(currentDate.getDate() + 1);

    //最大日期30天
    const currentDateAdd30 = new Date(currentDate);
    currentDateAdd30.setDate(currentDate.getDate() + 30);
    var endDate = new Date(props.end_date.split(' ')[0]);

    // 以项目结束时间和当前时间30天最小日期为结束日期
    const maxDate = ref('');
    watch(() => props.end_date, newValue => {
      console.log('end_date001---->', newValue);
      endDate = new Date(newValue.split(' ')[0]);
      console.log('endDate002----', endDate, currentDateAdd30, endDate < currentDateAdd30);
      maxDate.value = endDate < currentDateAdd30 ? endDate : currentDateAdd30;
    });
    const themeVars = reactive({
      pickerConfirmActionColor: '#00C4A1',
      tabFontSize: '15px',
      tabsBottomBarColor: '#000000',
      tabsBottomBarWidth: '24px',
      pickerOptionFontSize: '18px',
      calendarConfirmButtonHeight: '40px',
      buttonRoundRadius: '4px'
    });
    const selectedDateArray = ref([]);
    const formatter = day => {
      //day.topInfo = '已预约5';

      let dayStr = formatDate(day.date);
      props.disable_date_array.map(item => {
        if (item.date == dayStr) {
          day.type = 'disabled';
        }
      });
      if (selectedDateArray.value.includes(dayStr)) {
        console.log('duration------', props.duration);

        // 判断当前接口返回的数据中是否包含该字符串,有则添加类名
        if (props.duration == 1) {
          selectedDateArray.value.includes(dayStr) ? day.className = 'single-selected-day' : '';
        } else {
          console.log('duration------', props.duration);
          const index = selectedDateArray.value.indexOf(dayStr);
          if (index === 0) {
            // 设置样式为第一个选中日期
            day.className = 'first-selected-day';
            day.bottomInfo = '开始';
          } else if (index === selectedDateArray.value.length - 1) {
            // 设置样式为最后一个选中日期
            day.className = 'last-selected-day';
            day.bottomInfo = '结束';
          } else {
            day.className = 'selected-day';
          }
        }
      }
      return day;
    };
    const selectedDayInfo = ref('');
    const actionDisabled = ref(true);
    function onSelect(date) {
      selectedDateArray.value = [];
      const selectedDate = new Date(date);
      actionDisabled.value = false;

      // calendarRef.value?.scrollToDate(selectedDate);

      for (let index = 0; index < props.duration; index++) {
        const currentDate = new Date(selectedDate);
        currentDate.setDate(selectedDate.getDate() + index);

        // 格式化日期为 yyyy-mm-dd
        const formattedDate = formatDate(currentDate);
        selectedDateArray.value.push(formattedDate);
      }
      console.log('selectedDateArray-----', selectedDateArray.value);
      const month = String(selectedDate.getMonth() + 1).padStart(2, '0');
      const day = String(selectedDate.getDate()).padStart(2, '0');
      var num = 0;
      if (props.enabled_data_array.find(e => e.date == selectedDateArray.value[0])) {
        num = props.enabled_data_array.find(e => e.date == selectedDateArray.value[0]).num;
      }
      if (num > 0) {
        selectedDayInfo.value = month + '.' + day + '可预约，已有' + num + '家预约';
      } else {
        selectedDayInfo.value = month + '.' + day + '可预约';
      }
    }
    function formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    function onConfirm() {
      // 校验选择日期是否合法-末个日期是否超出最大日期、日期区间是否包括不可用日期

      const last_date_str = selectedDateArray.value[selectedDateArray.value.length - 1];
      const last_date = new Date(last_date_str);
      const set = new Set(props.disable_date_array);
      const hasIntersection = selectedDateArray.value.some(item => set.has(item));
      console.log('last-date--------->', last_date, maxDate.value);
      console.log('hasIntersection--------->', props.disable_date_array, selectedDateArray.value);
      if (last_date > maxDate.value) {
        // 超出了最大日期
        mdToast('所选日期超出最大允许日期');
        return;
      } else if (hasIntersection) {
        // 包含了不可用日期
        mdToast('所选日期包含不可用日期');
        return;
      }
      showCalendar.value = false;
      emit('conformCalendar', {
        'selectedDateArray': selectedDateArray.value
      });
    }
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_calendar = _resolveComponent("van-calendar");
      const _component_van_config_provider = _resolveComponent("van-config-provider");
      return _openBlock(), _createBlock(_component_van_config_provider, {
        "theme-vars": _unref(themeVars)
      }, {
        default: _withCtx(() => [_createVNode(_component_van_calendar, {
          ref_key: "calendarRef",
          ref: calendarRef,
          show: _unref(showCalendar),
          "onUpdate:show": _cache[0] || (_cache[0] = $event => _isRef(showCalendar) ? showCalendar.value = $event : null),
          "close-icon": "close",
          title: "预约时间",
          type: "single",
          "min-date": _unref(minDate),
          "max-date": maxDate.value,
          "show-mark": false,
          "confirm-text": "确定",
          "confirm-disabled-text": "请选择预约时间",
          formatter: formatter,
          color: "#00C4A1",
          style: {
            height: '612px'
          },
          "default-date": null,
          onSelect: onSelect,
          onConfirm: onConfirm
        }, {
          title: _withCtx(() => [_hoisted_1]),
          footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [selectedDayInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(selectedDayInfo.value), 1)) : _createCommentVNode("", true), _createVNode(_component_van_button, {
            class: "action-btn",
            disabled: actionDisabled.value,
            type: "primary",
            onClick: _withModifiers(onConfirm, ["stop"])
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(actionDisabled.value ? '请选择预约时间' : '确定'), 1)]),
            _: 1
          }, 8, ["disabled", "onClick"])])]),
          _: 1
        }, 8, ["show", "min-date", "max-date"])]),
        _: 1
      }, 8, ["theme-vars"]);
    };
  }
};